
export const AUTH_ERR_MSG = 'AUTH_ERR_MSG';
export const ERR_MSG = '抱歉出错了，请稍候重试，如有困难请联系客服';
const REQUEST_TIMEOUT = 10000;
import { appId, token } from './../../lib/auth/token';
import Url from 'url';

export const timeoutPromise = (ms, promise) => {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(new Error('promise timeout'));
    }, ms);
    promise.then(
      (res) => {
        clearTimeout(timeoutId);
        resolve(res);
      },
      (err) => {
        clearTimeout(timeoutId);
        reject(err);
      }
    );
  });
};

const responseAuth = (loginUrl, ignoreWxRedirect) => {
  return (response) => {
    if (response.status === 401) {
      if (response.headers.get('Wx-Redirect') && !ignoreWxRedirect) {
        window.location.href = response.headers.get('Wx-Redirect');
      } else {
        window.location.href = loginUrl;
      }
      throw new Error(AUTH_ERR_MSG);
    }
    if (response.status !== 200) {
      throw new Error(JSON.stringify(`${response.status}: ${response.statusText}`));
    }

    return response.json();
  };
};

// const responseError = () => {
//   return (json) => {
//     if (json.retCode !== 0) {
//       throw new Error(JSON.stringify(json));
//     }
//     return json;
//   };
// };

export const handleError = () => {
  return err => {
    if (err.message !== AUTH_ERR_MSG) {
      if (process.env.NODE_ENV !== 'production') {
        if (/ip(hone|od|ad)|android|WindowsPhone/i.test(window.navigator.userAgent)) {
          window.location.replace(`/error?msg=${encodeURIComponent(err.message)}`);
        }
        console.error(err);
      } else {
        if (err.message === 'promise timeout') {
          if (confirm('网络出现了问题,是否立即重试?')) {
            window.location.reload();
          } else {
            window.history.back();
          }
        } else {
          window.location.replace(`/error?msg=${encodeURIComponent(err.message)}`);
        }
        console.error(err);
        // alert(ERR_MSG);
      }
    }
  };
};

export const fetchRequest = (url, opt, rtm) => {
  const defOpt = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'thorgene-referer': window.location.href
    },
    loginUrl: `login.html?redirect=${encodeURIComponent(window.location.href)}`,
    ignoreWxRedirect: false
  };

  let option;
  if (opt) {
    option = Object.assign({}, defOpt, opt);
  } else {
    option = defOpt;
  }

  const urlObj = Url.parse(url, true);

  urlObj.search = null;

  if (urlObj.query.token !== token) {
    urlObj.query.token = token;
  }

  if (urlObj.query.appid !== appId) {
    urlObj.query.appid = appId;
  }

  const fetchUrl = Url.format(urlObj);

  const requestTimeout = rtm || REQUEST_TIMEOUT;

  return timeoutPromise(requestTimeout, fetch(fetchUrl, option))
    .then(responseAuth(option.loginUrl, option.ignoreWxRedirect));
};


// 单页跳出页面字体错乱处理方法
export const htmlFontSizeRender = () => {
  const html = document.documentElement;
  const width = html.clientWidth;
  html.style.fontSize = width / 7.5 + 'px';//eslint-disable-line

  (function() {//eslint-disable-line
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {//eslint-disable-line
      handleFontSize();//eslint-disable-line
    } else {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);//eslint-disable-line
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", handleFontSize);//eslint-disable-line
        document.attachEvent("onWeixinJSBridgeReady", handleFontSize);  }//eslint-disable-line
    }
    function handleFontSize() {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });//eslint-disable-line
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on('menu:setfont', function() {//eslint-disable-line
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize' : 0 });//eslint-disable-line
      });
    }
  })();
};

//  新的发送请求方法,包含完整的出错处理
// export const handleRequest = (fetchPara, callback) => {
//   const defOpt = {
//     method: 'GET',
//     headers: {
//       Accept: 'application/json',
//       'Content-Type': 'application/json'
//     },
//     loginUrl: `login.html?redirect=${encodeURIComponent(window.location.href)}`,
//     ignoreWxRedirect: false
//   };
//
//   const genFetch = ({url, opt}) => {
//     let option;
//     if (opt) {
//       option = Object.assign({}, defOpt, opt);
//     } else {
//       option = defOpt;
//     }
//
//     const reg = /\?/;
//     const match1 = url.match(reg);
//     let fetchUrl = '';
//     if (match1) {
//       fetchUrl = `${url}&appid=${appId}`;
//     } else {
//       fetchUrl = `${url}?appid=${appId}`;
//     }
//     return {fetchUrl, option};
//   };
//
//   let fetchPromise = [];
//   if (Array.isArray(fetchPara)) {
//     fetchPara.forEach(item => {
//       const para = genFetch(item);
//       fetchPromise.push(timeoutPromise(REQUEST_TIMEOUT, fetch(para.fetchUrl, para.option))
//         .then(responseAuth(para.option.loginUrl, para.option.ignoreWxRedirect)));
//     });
//   } else {
//     const para = genFetch(fetchPara);
//     fetchPromise = timeoutPromise(REQUEST_TIMEOUT, fetch(para.fetchUrl, para.option))
//       .then(responseAuth(para.option.loginUrl, para.option.ignoreWxRedirect));
//   }
//
//   return fetchPromise
//     .then(responseError())
//     .then(callback)
//     .catch(err => handleError(err));
// };




// WEBPACK FOOTER //
// ./src/lib/network/request.js